import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "normalize.css/normalize.css";
import "bootstrap/dist/css/bootstrap.rtl.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "assets/global.scss";
import { BrowserRouter } from "react-router-dom";
import { ScrollToTop } from "react-router-scroll-to-top";

ReactDOM.render(
  <BrowserRouter>
    <ScrollToTop />

    <App />
  </BrowserRouter>,
  document.getElementById("root")
);
